import { Action, createSlice, PayloadAction, Slice } from "@reduxjs/toolkit";
import GAMES from "../../config/games";
import { ReducerAction } from "react";

const initialState = {
  items: GAMES,
  hoverItem: {
    name: "",
  },
};

type NavigationState = typeof initialState;

export const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    setNavItem: (state: NavigationState, action: PayloadAction<any>) => {
      state.hoverItem = action.payload;
    },
  },
  extraReducers: {},
});

export const { setNavItem } = navigationSlice.actions;
export default navigationSlice.reducer;
